import React from 'react';
import './ChannelOwnerDashboard.css';

const ChannelOwnerDashboard = () => {
  const channelStats = {
    channelName: 'Tech Master Channel',
    totalCreators: 12,
    monthlyViews: '450K',
    channelRevenue: '₹28,500',
    topCreator: 'TechGuru',
    pendingApprovals: 3,
    activeVideos: 67,
    avgEngagement: '4.2%'
  };

  const creators = [
    { id: 1, name: 'TechGuru', videos: 15, views: '120K', revenue: '₹8,500', status: 'active' },
    { id: 2, name: 'GadgetReview', videos: 8, views: '85K', revenue: '₹5,200', status: 'active' },
    { id: 3, name: 'CodeMaster', videos: 12, views: '95K', revenue: '₹6,800', status: 'active' }
  ];

  return (
    <div className="channel-owner-dashboard">
      <div className="dashboard-header">
        <h2>Channel Owner Dashboard</h2>
        <p>Managing: {channelStats.channelName}</p>
      </div>

      <div className="channel-stats">
        <div className="stat-card">
          <h3>Total Creators</h3>
          <p className="stat-value">{channelStats.totalCreators}</p>
        </div>
        <div className="stat-card">
          <h3>Monthly Views</h3>
          <p className="stat-value">{channelStats.monthlyViews}</p>
        </div>
        <div className="stat-card">
          <h3>Channel Revenue</h3>
          <p className="stat-value">{channelStats.channelRevenue}</p>
        </div>
        <div className="stat-card">
          <h3>Active Videos</h3>
          <p className="stat-value">{channelStats.activeVideos}</p>
        </div>
      </div>

      <div className="creators-section">
        <h3>Your Creators Performance</h3>
        <table className="creators-table">
          <thead>
            <tr>
              <th>Creator Name</th>
              <th>Videos</th>
              <th>Views</th>
              <th>Revenue</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {creators.map(creator => (
              <tr key={creator.id}>
                <td>{creator.name}</td>
                <td>{creator.videos}</td>
                <td>{creator.views}</td>
                <td>{creator.revenue}</td>
                <td><span className={`status ${creator.status}`}>{creator.status}</span></td>
                <td>
                  <button className="btn-small">View</button>
                  <button className="btn-small">Manage</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="channel-actions">
        <button className="action-btn primary">Add Creator</button>
        <button className="action-btn">Channel Analytics</button>
        <button className="action-btn">Revenue Report</button>
        <button className="action-btn">Content Calendar</button>
      </div>
    </div>
  );
};

export default ChannelOwnerDashboard;
